module.exports = __webpack_public_path__ + "media/promo/promo/images/link-1-5997f004b15a7f62506ab43d917707da.svg";